import { Box, Button, Flex, FormLabel, Input, Text } from "@chakra-ui/react";
import { HStack, Heading, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import ProductsDropdown from "../../components/ProductsDropdown";
import { useDispatch, useSelector } from "react-redux";
import SectorCategoriesDropdown from "../../components/SectorCategoriesDropdown";
import { getSectorsCategories } from "../../actions/sector/sectorActions";
import { getSectorCategoryProductsApi } from "../../api/productApi";
import { addClient } from "../../actions/client/clientActions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CreateClient = ({ clientData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [curretnInputFocous, setCurrentInputFocous] = useState("");

  const [dataError, setDataError] = useState({
    organization: false,
    addressLine1: false,
    addressLine2: false,
    pincode: false,
    products: false,
  });

  const changeHandler = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [formData, setFormData] = useState({
    organization: "",
    addressLine1: "",
    addressLine2: "",
    pincode: "",
    products: [],
  });

  const { loading: categoriesLoading, data: sectorData } = useSelector(
    (state) => state.sectorReducer
  );

  const { loading } = useSelector((state) => state.clientAddReducer);

  const [selectedSectorCategory, setSelectedSectorCategory] = useState(null);
  const handleSectorCategoryChange = (selectedSectorCategory) => {
    setSelectedSectorCategory(selectedSectorCategory?.value);
  };

  useEffect(() => {
    fetchSectorCategories();
  }, []);

  const fetchSectorCategories = async () => {
    dispatch(getSectorsCategories());
  };

  const handleFormSubmit = (e) => {
    if (formData.organization === "") {
      toast.error("Please enter organization name", {
        position: "bottom-center",
        toastId: "products-mismatch",
      });
      return ;
    } else {
      if (selectedSectorCategory) {
        if (
          formData?.products &&
          (formData?.products.length < 3 || formData?.products.length > 20)
        ) {
          toast.error(
            "Please select Minimum 3 required/Maximum 20 available",
            {
              position: "bottom-center",
              toastId: "products-mismatch",
            }
          );
          return;
        }
      } else {
        toast.error("Please select industry category", {
          position: "bottom-center",
          toastId: "industry-mismatch",
        });
        return;
      }
    }
    dispatch(
      addClient(
        {
          companyName: formData.organization,
          companyAddressLine1: formData.addressLine1,
          companyAddressLine2: formData.addressLine2,
          companyPincode: formData.pincode,
          sectorCategory: selectedSectorCategory,
          products: formData.products,
        },
        navigate
      )
    );
  };

  return (
    <>
      <VStack w={"100%"} bg={"white"} p={1} spacing={4} borderRadius={10}>
        <Box>
          <Heading size={"md"} fontWeight={600} textAlign={"left"} mb={3}>
            Your Organization
          </Heading>
          <Box mb={4}>
            <FormLabel
              fontWeight={400}
              fontSize={"13px"}
              textColor={"#0C543C"}
              mb={1}
            >
              Organization name
            </FormLabel>
            <Input
              mb={3}
              name="organization"
              type="text"
              placeholder={
                curretnInputFocous === "organization" ? "" : "Organization name"
              }
              focusBorderColor="#30d5c8"
              focusborderwidth="5px"
              transition="height 0.3s"
              fontWeight={"bold"}
              onFocus={() => setCurrentInputFocous("organization")}
              onBlur={() => {
                setCurrentInputFocous("");
                setDataError((prevDataError) => ({
                  ...prevDataError,
                  organization: formData.organization.trim() === "", // Example validation rule: Organization is required
                }));
              }}
              isInvalid={dataError.organization}
              errorBorderColor="red.500"
              _placeholder={{
                fontWeight: "normal",
                color: "#0C543C",
              }}
              _focus={{
                height: "3rem",
                borderLeft: "5px solid #30d5c8",
              }}
              onChange={changeHandler}
            />
          </Box>
          <HStack
            flexWrap="wrap"
            spacing={{ base: 4, md: 8 }}
            width={{ base: "100%", md: "auto" }}
            mb={4}
          >
            <Text
              width={{ base: "100%", md: "8rem" }}
              textAlign={"left"}
              whiteSpace="nowrap"
              ml={"4px"}
            >
              Industry Category
            </Text>

            <Box
              width={{ base: "100%", md: "21rem" }}
              pt={{ base: 2, md: "0" }}
            >
              {categoriesLoading ? (
                <p>Loading categories...</p>
              ) : (
                <SectorCategoriesDropdown
                  sectorCategories={sectorData?.data}
                  selectedSectorCategory={selectedSectorCategory}
                  handleSectorCategoryChange={handleSectorCategoryChange}
                />
              )}
            </Box>
          </HStack>
          {selectedSectorCategory && (
            <Flex
              width={{ base: "100%", md: "auto" }}
              wrap={"wrap"}
              alignItems={"flex-start"}
              direction={{ base: "column", md: "row" }}
              justifyContent={{ base: "flex-start", md: "space-between" }}
            >
              <Text
                width={{ base: "100%", md: "9rem" }}
                pt={{ base: "1rem", md: "0" }}
                textAlign={"left"}
                ml={{ base: "0", md: "10px" }}
              >
                Product
              </Text>

              <Box w={{ base: "100%", md: "21rem" }}>
                <Text fontSize={"14px"} fontWeight={500}>
                  {formData.products.length === 0
                    ? "Minimum 3 required/Maximum 20 available"
                    : formData.products.length < 3
                    ? "Minimum 3 required"
                    : "Maximum 20 available"}
                </Text>
                <ProductsDropdown
                  selectedSectorCategory={selectedSectorCategory}
                  fetchDataFunction={getSectorCategoryProductsApi}
                  placeholder="Search Products..."
                  isMulti
                  handleOptionChange={(selectedOptions) => {
                    const products = selectedOptions.map((val) => val.value);
                    if (formData.products.length < 20) {
                      setFormData((prev) => ({
                        ...prev,
                        products,
                      }));
                    }
                  }}
                  _focus={{
                    height: "3rem",
                    borderLeft: "5px solid #30d5c8",
                  }}
                />
              </Box>
            </Flex>
          )}
          <Box mb={4}>
            <FormLabel
              fontWeight={400}
              fontSize={"13px"}
              textColor={"#0C543C"}
              mb={1}
            >
              Address Line 1
            </FormLabel>
            <Input
              name="addressLine1"
              type="text"
              placeholder={
                curretnInputFocous === "addressLine1" ? "" : "Address Line 1"
              }
              focusBorderColor="#30d5c8"
              focusborderwidth="5px"
              transition="height 0.3s"
              fontWeight={"bold"}
              onFocus={() => setCurrentInputFocous("addressLine1")}
              onBlur={() => {
                setCurrentInputFocous("");
                setDataError((prevDataError) => ({
                  ...prevDataError,
                  addressLine1: formData.addressLine1.trim() === "",
                }));
              }}
              isInvalid={dataError.addressLine1}
              errorBorderColor="red.500"
              _placeholder={{
                fontWeight: "normal",
                color: "#0C543C",
              }}
              _focus={{
                height: "3rem",
                borderLeft: "5px solid #30d5c8",
              }}
              onChange={changeHandler}
            />
          </Box>
          <Box mb={4}>
            <FormLabel
              fontWeight={400}
              fontSize={"13px"}
              textColor={"#0C543C"}
              mb={1}
            >
              Address Line 2
            </FormLabel>
            <Input
              name="addressLine2"
              type="text"
              placeholder={
                curretnInputFocous === "addressLine2" ? "" : "Address Line 2"
              }
              focusBorderColor="#30d5c8"
              focusborderwidth="5px"
              transition="height 0.3s"
              fontWeight={"bold"}
              onFocus={() => setCurrentInputFocous("addressLine2")}
              onBlur={() => {
                setCurrentInputFocous("");
                setDataError((prevDataError) => ({
                  ...prevDataError,
                  addressLine2: formData.addressLine2.trim() === "",
                }));
              }}
              isInvalid={dataError.addressLine2}
              errorBorderColor="red.500"
              _placeholder={{
                fontWeight: "normal",
                color: "#0C543C",
              }}
              _focus={{
                height: "3rem",
                borderLeft: "5px solid #30d5c8",
              }}
              onChange={changeHandler}
            />
          </Box>
          <HStack justify={"flex-start"} spacing={4}>
            <Box mb={4}>
              <FormLabel
                fontWeight={400}
                fontSize={"13px"}
                textColor={"#0C543C"}
                mb={1}
              >
                Enter Pincode
              </FormLabel>
              <Input
                name="pincode"
                type="number"
                placeholder={
                  curretnInputFocous === "pincode" ? "" : "Enter Pincode"
                }
                focusBorderColor="#30d5c8"
                focusborderwidth="5px"
                transition="height 0.3s"
                fontWeight={"bold"}
                onFocus={() => setCurrentInputFocous("pincode")}
                onBlur={() => {
                  setCurrentInputFocous("");
                  const isValidPincode = /^\d{6}$/.test(formData.pincode); // Check if pincode is exactly 6 digits
                  setDataError((prevDataError) => ({
                    ...prevDataError,
                    pincode: !isValidPincode,
                  }));
                }}
                isInvalid={dataError.pincode}
                errorBorderColor="red.500"
                _placeholder={{
                  fontWeight: "normal",
                  color: "#0C543C",
                }}
                _focus={{
                  height: "3rem",
                  borderLeft: "5px solid #30d5c8",
                }}
                onChange={changeHandler}
              />
            </Box>
          </HStack>

          <Box>
            <Button
              bg={"#0C543C"}
              color={"white"}
              onClick={handleFormSubmit}
              mb={4}
            >
              {loading ? "Processing..." : "Submit"}
            </Button>
          </Box>
        </Box>
      </VStack>
    </>
  );
};

export default CreateClient;
